export const getTextSelectionRange = (): Range | null => {
  if (window.getSelection) {
    const selection = window.getSelection()
    if (selection !== null && selection.toString()) {
      return selection.getRangeAt(0)
    }
  }

  return null
}
